<div class="d-flex flex-column gap-3 h-100 overflow-hidden">
  <div class="flex-fill overflow-hidden">
    <div class="p-4 h-100 rounded-4 bg-light">
      <div class="d-flex flex-column h-100">
        <div class="d-flex align-items-center mb-4">
          <i class="bi bi-chat-dots me-3"></i>
          <h3 class="mb-0">Lot Communication</h3>
        </div>
        <div class="flex-fill overflow-y-auto me-n4 pe-3">
          <div class="row gy-3">
            @for (notes of notes(); track $index) {
              <div class="col-12">
                <div
                  class="align-items-start p-3 rounded-4 d-flex h-100 shadow-sm"
                  [ngClass]="{
                    'bg-info-medium': noteToUpdate()?.id === notes.id,
                    'bg-secondary-subtle':
                      noteToUpdate()?.id !== notes.id && notes?.createdByUserId !== _authService.getUser().id,
                    'bg-white': noteToUpdate()?.id !== notes.id && notes?.createdByUserId === _authService.getUser().id
                  }"
                >
                  <div class="d-flex flex-column align-items-baseline w-100">
                    <div class="d-flex ms-auto align-items-center w-100 gap-2 mb-2">
                      <span
                        class="badge bg-info-subtle text-info fw-500 fs-14 d-inline-flex"
                        [ngbTooltip]="'Note Type'"
                        [placement]="'top'"
                      >
                        {{ notes?.noteTypeCode }}
                      </span>
                      <div class="ms-auto d-flex align-items-center gap-2">
                        <p class="ms-auto fw-400 fs-14 mb-0">
                          <span>Created By:</span>
                          <span class="fw-500"> {{ notes?.createdBy }} on {{ notes?.createdAt | dateFormat }}</span>
                        </p>
                        @if (noteToUpdate()?.id === notes.id) {
                          <span class="bg-info badge fw-400 me-1">Editing</span>
                        }
                      </div>
                    </div>
                    <p class="w-100"><span class="fw-500 me-2">Notes:</span>{{ notes?.note }}</p>
                    @if (notes?.voiceNoteUrl) {
                      <audio controls [src]="notes?.voiceNoteUrl" class="w-100"></audio>
                    }
                    @if (notes?.voiceNoteTranscription) {
                      <p class="bg-gray-200 px-2 py-1 rounded-3 text-muted d-block mt-2 fst-italic mb-0 w-100">
                        <span class="fw-500">Transcript:</span> {{ notes?.voiceNoteTranscription }}<br />
                      </p>
                    }
                  </div>

                  @if (notes?.createdByUserId === _authService.getUser().id && canWriteDeals()) {
                    <div class="dropdown">
                      <div class="dropdown-toggle svg-24" data-bs-toggle="dropdown">
                        <i class="bi bi-three-dots-vertical"></i>
                      </div>
                      <div class="dropdown-menu">
                        <div class="dropdown-item" (click)="editNote(notes)">Edit</div>
                        <div class="dropdown-item" (click)="deleteNoteConfirm(notes)">Delete</div>
                      </div>
                    </div>
                  }
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
  <lib-notes [recordingToUpdate]="recordingToUpdate() ?? null" (saveNote)="saveNote()"></lib-notes>
</div>
